import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./app-slice";
import usersReducer from "redux-toolkit/users/slice";
import dashboardReducer from "redux-toolkit/dashboard/slice";
import predictionsReducer from "redux-toolkit/predictions/slice";
import promisesReducer from "redux-toolkit/promises/slice";
import predictorsReducer from "redux-toolkit/predictors/slice";
import mainContentReducer from "redux-toolkit/main/slice";
import surveysReducer from "redux-toolkit/surveys/slice";

const combinedReducer = combineReducers({
  app: appReducer,
  users: usersReducer,
  dashboard: dashboardReducer,
  predictions: predictionsReducer,
  predictors: predictorsReducer,
  main: mainContentReducer,
  surveys: surveysReducer,
  promises: promisesReducer,
});

export const store = configureStore({
  reducer: combinedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});
